// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"128":"5de56691","245":"66000970"}[chunkId] + ".chunk.js";
};